/** WAŻNE
 * Test implementuje algorytm sprawdzania poprawności numeru dowodu osobistego. 
 * Strona na której można znaleźć więcej informacji na temat algorytmu 
 * oraz sprawdzić czy podany numer dowodu jest poprawny:
 * https://www.czerwona-skarbonka.pl/walidator-danych-walidacja-pesel-regon-nip-krok-po-kroku/ 
*/

import { IWages, LettersValues } from './ValidationsTypes'
 
 export const Wages: IWages = {
   0: 7,
   1: 3,
   2: 1,
   3: 9,
   4: 7,
   5: 3,
   6: 1,
   7: 7,
   8: 3,
 };
 
 export const Values: LettersValues = {
   A: 10,
   B: 11,
   C: 12,
   D: 13,
   E: 14,
   F: 15,
   G: 16,
   H: 17,
   I: 18,
   J: 19,
   K: 20,
   L: 21,
   M: 22,
   N: 23,
   O: 24,
   P: 25,
   Q: 26,
   R: 27,
   S: 28,
   T: 29,
   U: 30,
   V: 31,
   W: 32,
   X: 33,
   Y: 34,
   Z: 35,
 };

const convertIntoValues = (value : string) : number[]=>{
    var lettersValues = [];
    for(let index=0; index<value.length; index++){
        if(index < 3){
            lettersValues.push(Values[value[index]]);
        }else{
            lettersValues.push(Number.parseInt(value[index]));
        }
    }
    return lettersValues;
}

export const isPersonalIdNumberValid = (value:string) : boolean =>{
    var sum = 0;
    var letterValues = convertIntoValues(value);
    for (let index = 0; index < letterValues.length; index++) {
        const element = letterValues[index];
        const wage = Wages[index];
        sum += (element * wage);
    }
    return sum % 10 === 0;
}


/**
   Funkcja sprawdzająca poprawność numru dowodu osobistego na podstawie poszczególnych wag. 
*/
export const hasPersonalIdNumberCorrectFormat = {
   name: 'hasPersonalIdNumberCorrectFormat',
   message: 'Nieprawidłowa wartość',
   test: (personalIdNumberToCheck: string | undefined) => {
      if(personalIdNumberToCheck!== undefined && personalIdNumberToCheck?.length === 9){
         return isPersonalIdNumberValid(personalIdNumberToCheck)
      }
      else return false
   },
 }